import React from 'react';
import { Users, CheckCircle, Clock, Award } from 'lucide-react';
export function TrustIndicators() {
  const stats = [{
    label: 'Years Experience',
    value: '10+',
    icon: Clock
  }, {
    label: 'Projects Delivered',
    value: '500+',
    icon: CheckCircle
  }, {
    label: 'Happy Clients',
    value: '200+',
    icon: Users
  }, {
    label: 'Support',
    value: '24/7',
    icon: Award
  }];
  return <section id="trust" className="py-16 bg-navy-900 text-white" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="text-center mb-12" data-id="element-179">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-180">
            Trusted by businesses across the UK
          </h2>
          <p className="text-navy-200 max-w-2xl mx-auto" data-id="element-181">
            We pride ourselves on delivering excellence and building long-term
            partnerships with our clients.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-182">
          {stats.map((stat, index) => <div key={index} className="p-6 rounded-lg bg-navy-800/50 backdrop-blur-sm border border-navy-700" data-id="element-183">
              <div className="flex justify-center mb-4" data-id="element-184">
                <stat.icon className="h-8 w-8 text-blue-400" data-id="element-185" />
              </div>
              <div className="text-4xl font-bold text-white mb-2" data-id="element-186">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-navy-200 uppercase tracking-wider" data-id="element-187">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}